import Modal from '@/shared/ui/Modal';

// The backend edit rewrites the message and deletes every later message in
// the conversation before answering again — irreversible, hence the red
// destructive confirm.
export default function AgentEditConfirmModal({
  onKeep,
  onConfirm,
}: {
  onKeep: () => void;
  onConfirm: () => void;
}) {
  return (
    <Modal fullScreen={false} withoutCross closeModal={onKeep}>
      <div className="flex w-88.5 max-w-[calc(100vw-32px)] flex-col items-center gap-3xl px-xl pt-2xl pb-2xl">
        <div className="flex flex-col items-center gap-m text-center">
          <p className="text-h2 font-medium text-gray-text">
            Edit this message?
          </p>
          <p className="text-body-lg font-medium text-gray">
            Everything after it in this conversation will be deleted and the
            answer written again.
          </p>
        </div>
        <div className="flex w-full gap-l">
          <button
            type="button"
            onClick={onKeep}
            className="flex h-12 flex-1 items-center justify-center rounded-xs px-l text-body-lg font-bold text-gray-text transition-opacity hover:opacity-80"
          >
            Keep
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="flex h-12 flex-1 items-center justify-center rounded-md bg-red-default px-l text-body-lg font-bold text-gray-inverse transition-opacity hover:opacity-90"
          >
            Edit message
          </button>
        </div>
      </div>
    </Modal>
  );
}
